export default "__VITE_ASSET__CW$FS1xI__"